import { BaseModel } from "./base/base.model";

export class AppWorkCenters extends BaseModel {
  workCenter1?: string;
  workplaceCode?: Number;
  name?: string;
  company?: string;
  companyId?: string;
  environment?: string;
  enabled?: boolean;
  geolocation?: boolean;
  address?: string;
  coordinates?: string;
  createdAt?: string;
  modifiedOn?: string;

  constructor(initValues?: Partial<AppWorkCenters>) {
    super();
    Object.assign(this, initValues);
  }
}
